module.exports = __webpack_public_path__ + "bcb399e1185ab5d63a1fa7f71da09b95.MP3";